"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStripeMetadata = exports.isStripeMetadataType = exports.AllStripeMetadataTypes = void 0;
const validation_1 = require("../validator/validation");
exports.AllStripeMetadataTypes = ['subscription', 'customer'];
exports.isStripeMetadataType = (0, validation_1.isLiteral)(...exports.AllStripeMetadataTypes);
exports.isStripeMetadata = (0, validation_1.isSomeOf)((0, validation_1.isObjectOf)({
    type: exports.isStripeMetadataType,
    id: (0, validation_1.optional)(validation_1.isString),
    url: (0, validation_1.optional)(validation_1.isString),
}), validation_1.isNull, validation_1.isUndefined);
//# sourceMappingURL=metadata.js.map